import { useEffect, useState } from 'react';
import {
    fetchDocumentMediaBlob,
    getDocumentMediaSpaHref,
    isDocumentMediaPath,
} from '../redux/downloadDocumentMedia';
import { acquireBlobUrl, releaseBlobUrl } from './mediaBlobCache';

export const useAuthenticatedDocumentMedia = (relativeUrl) => {
    const [blobUrl, setBlobUrl] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const isMediaPath = isDocumentMediaPath(relativeUrl);
    const downloadHref = isMediaPath ? getDocumentMediaSpaHref(relativeUrl, { download: true }) : null;

    useEffect(() => {
        if (!relativeUrl || !isMediaPath) {
            setBlobUrl(null);
            setLoading(false);
            setError(null);
            return undefined;
        }

        let cancelled = false;

        setLoading(true);
        setError(null);
        setBlobUrl(null);

        acquireBlobUrl(relativeUrl, async () => {
            const { blob, contentType } = await fetchDocumentMediaBlob(relativeUrl);
            const typedBlob = blob.type && blob.type !== 'application/octet-stream'
                ? blob
                : new Blob([blob], { type: contentType || 'application/octet-stream' });

            return URL.createObjectURL(typedBlob);
        })
            .then((objectUrl) => {
                if (!cancelled) {
                    setBlobUrl(objectUrl);
                }
            })
            .catch((err) => {
                if (!cancelled) {
                    setError(err);
                }
            })
            .finally(() => {
                if (!cancelled) {
                    setLoading(false);
                }
            });

        return () => {
            cancelled = true;
            releaseBlobUrl(relativeUrl);
        };
    }, [relativeUrl, isMediaPath]);

    return {
        blobUrl,
        loading,
        error,
        isMediaPath,
        downloadHref,
    };
};
